import { MEDIA_TYPES } from '../../constants';

function detectTypeRequest(file) {
  const type = file?.type || '';
  if (type.startsWith('image/')) return MEDIA_TYPES.IMAGE;
  if (type.startsWith('video/')) return MEDIA_TYPES.APPLICATION;
  if (type === 'application/') return MEDIA_TYPES.APPLICATION;

  return MEDIA_TYPES.APPLICATION;
}

function detectType(file) {
  const type = file?.type || '';
  if (type.startsWith('image/')) return MEDIA_TYPES.IMAGE;
  if (type.startsWith('video/')) return MEDIA_TYPES.VIDEO;
  if (type === 'application/') return MEDIA_TYPES.APPLICATION;

  return MEDIA_TYPES.APPLICATION;
}

export default detectType;

export { detectTypeRequest };
